import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TestMapComponent } from './test-map.component';

const routes: Routes = [
  {
    path: '',
    component: TestMapComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TestMapRoutingModule {}
